/** Compute Levenshtein edit distance between two strings. */
export function levenshtein(a: string, b: string): number {
  const m = a.length
  const n = b.length
  const dp: number[][] = Array.from({ length: m + 1 }, (_, i) =>
    Array.from({ length: n + 1 }, (_, j) => (i === 0 ? j : j === 0 ? i : 0)),
  )
  for (let i = 1; i <= m; i++) {
    for (let j = 1; j <= n; j++) {
      const diagCost = dp[i - 1]?.[j - 1] ?? 0
      const aboveCost = dp[i - 1]?.[j] ?? 0
      const leftCost = dp[i]?.[j - 1] ?? 0
      if (a[i - 1] === b[j - 1]) {
        dp[i]![j] = diagCost
      } else {
        dp[i]![j] = 1 + Math.min(aboveCost, leftCost, diagCost)
      }
    }
  }
  return dp[m]![n]!
}
